<app-toolbar></app-toolbar>
<div *ngIf="route.children.length === 0">
  <mat-progress-bar *ngIf="loading == true" mode="indeterminate" color="warn"></mat-progress-bar>
  <mat-toolbar-row fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="20px" class="toolbar">
    <div class="action-lbl">
      Actions:
    </div>
    <button mat-raised-button color="accent" routerLink="/payment/add">
      Add Payment
    </button>
    <button mat-raised-button (click)="getPayment()">
      Refresh
    </button>
    <mat-form-field [floatLabel]="'never'">
      <mat-label>Sort by</mat-label>
      <mat-select [(ngModel)]="sort_option" (selectionChange)="getPayment()" [disableOptionCentering]="true">
        <mat-option value="p.created_at-desc">
          Date DESC
        </mat-option>
        <mat-option value="p.created_at-asc">
          Date ASC
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field [floatLabel]="'never'">
      <input type="text" matInput placeholder="Search" [(ngModel)]="search_qry" (input)="getPayment()" />
    </mat-form-field>
    <mat-form-field [floatLabel]="'never'">
      <input matInput [matDatepicker]="picker" [(ngModel)]="date" (dateChange)="getPayment()">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </mat-toolbar-row>
  <div class="container">
    <mat-list>
      <mat-list-item *ngFor="let item of items; let lastItem = last">
        <div mat-line> {{item.vendor}} made payment on {{item.created_at|date: 'dd/MM/yyyy'}} for ₹{{item.paid_amount|number:'1.2-2'}} behalf of bill No. #{{item.order_id}}</div>
        <div mat-line> {{item.remark}} </div>
        <mat-action-list>
          <button mat-button (click)="showProducts(item)">
            Info
          </button>
        </mat-action-list>
        <mat-divider *ngIf="!lastItem"></mat-divider>
      </mat-list-item>
    </mat-list>
  </div>
</div>
<router-outlet></router-outlet>